<div class="w-full h-full overflow-auto relative min-h-full">
  <div #typeformContainer class="w-full h-full typeform-container"></div>
  @if (showButtons) {
    <div class="flex gap-2 w-full p-8 pt-0 justify-end" [@fadeInOut]>
      <rk-button
        [variant]="'secondary'"
        (buttonClick)="closeTutorial()"
        [text]="'tutorial-modal.close' | translate"
      ></rk-button>
      <rk-button
        (buttonClick)="validateTutorial()"
        [text]="'tutorial-modal.validate' | translate"
      ></rk-button>
    </div>
  }
  <fa-icon
    class="absolute top-6 right-6 text-xl opacity-70 cursor-pointer"
    [icon]="'xmark'"
    (click)="closeTutorial()"
  ></fa-icon>
</div>
